
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 130 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.914 22.008h7.793l-4.12-6.56-7.563 11.86h-3.442l9.198-14.245a2.18 2.18 0 011.806-.924c.715 0 1.382.336 1.77.9l9.235 14.269h-3.442l-1.624-2.65h-7.89l-1.72-2.65h-.001zm35.752 2.65V12.282h-2.92V25.87c0 .371.145.731.423 1.007a1.5 1.5 0 001.067.431h13.319l1.721-2.65h-13.61zm-48.32-2.219c2.836 0 5.139-2.266 5.139-5.072s-2.303-5.084-5.139-5.084H31.57v15.025h2.92V14.933h9.664a2.439 2.439 0 012.447 2.435 2.438 2.438 0 01-2.447 2.434l-8.234-.012 8.718 7.518h4.242l-5.866-4.868h1.333zm-30.75 4.869c-4.192 0-7.594-3.358-7.594-7.506 0-4.15 3.402-7.518 7.594-7.518h8.827c4.193 0 7.592 3.369 7.592 7.518 0 4.148-3.4 7.506-7.593 7.506h-8.826zm8.63-2.65c2.716 0 4.916-2.17 4.916-4.857 0-2.685-2.2-4.868-4.916-4.868h-8.435c-2.715 0-4.915 2.183-4.915 4.869 0 2.685 2.2 4.856 4.915 4.856h8.435zm55.46 2.65c-4.193 0-7.598-3.358-7.598-7.506 0-4.15 3.406-7.518 7.599-7.518H88.17l-1.709 2.65h-8.58c-2.715 0-4.92 2.182-4.92 4.868 0 2.685 2.205 4.856 4.92 4.856h10.531l-1.72 2.65h-9.005zm35.716-2.65c-2.242 0-4.144-1.487-4.726-3.538h12.483l1.721-2.65h-14.204a4.914 4.914 0 014.726-3.537h8.569l1.732-2.65h-10.495c-4.193 0-7.599 3.37-7.599 7.518 0 4.149 3.406 7.506 7.599 7.506h9.005l1.721-2.65h-10.532z","fill":"#545C69"}})])
          )
        }
      }
    